export const scrollIntoTheView = (id: string) => {
  const element = document.getElementById(id) as HTMLElement

  if (!element) return

  element.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
    inline: 'nearest'
  })
}

export const uploadAttachmentErrors = (
  maxFiles = 5,
  maxFileSizeMB = 5,
  accepted = ['jpg', 'jpeg', 'png', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv', 'ppt', 'pptx']
): Record<string, string> => {
  return {
    'too-many-files': `Oops! You can't upload more than ${maxFiles} files.`,
    'file-too-large': `Oops! Your file size is more than ${maxFileSizeMB}MB.`,
    'file-invalid-type': `File type must be ${accepted.join(', ')}`
  }
}

export * from './get-unique-menus'
